<template>
  <div class="page">
    <OpdrachtenHeader @showVoegOpdrachtToeModal="$emit('showVoegOpdrachtToeModal')" />

    <div class="page-wrapper">
      <div class="selectorsContainer">
        <div class="selector" :class="{ activeList: selectedView == view.toLowerCase() }" @click="selectedView = view.toLowerCase()" v-for="(view, i) in views" :key="i">
          <span>
            {{ view }}
          </span>
          <div class="bolletje" v-if="view === 'Gearchiveerd' && unauthorizedArchivation.length" />
        </div>
      </div>

      <div class="listholder">
        <OpdrItemsHeader />

        <div @click="openOpdracht(opdracht.id), $emit('select-opdracht', opdracht.id)" v-for="(opdracht, i) in opdrachtenFilteredByCurrentView" :key="i">
          <OpdrachtItem :class="{ selected: $store.state.opdracht.id === opdracht.id }" :opdracht="opdracht" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"

import { useStore } from "vuex"

import Vue2Filters from "vue2-filters"

import OpdrachtenHeader from "./OpdrachtenHeader"
import OpdrachtItem from "./OpdrachtItem"
import OpdrItemsHeader from "./OpdrItemsHeader"

export default {
  name: "opdrachten",
  components: {
    OpdrachtenHeader,
    OpdrachtItem,
    OpdrItemsHeader
  },
  mixins: [Vue2Filters.mixin],

  setup() {
    const store = useStore()

    const openOpdracht = id => store.commit("opdracht/setId", id)

    return { openOpdracht }
  },

  data() {
    return {
      views: ["Nieuw", "Alle", "Geaccepteerd", "Lopend", "Gearchiveerd"],
      selectedView: "alle"
    }
  },

  computed: {
    ...mapGetters(["allOpdrachten"]),

    unauthorizedArchivation() {
      return this.allOpdrachten.filter(e => {
        if (!e.status || !e.status?.length) return false

        const ting = e.status[e.status.length - 1]
        if (ting.event === 0) return !ting.approved
      })
    },

    filteredOpdrachten() {
      console.log(this.allOpdrachten)

      return this.allOpdrachten
        .filter(opdracht => {
          const opdrachtnummer = opdracht.metadata.opdrachtNummer
          return opdrachtnummer
            ?.toString()
            ?.toLowerCase()
            ?.includes(store.state.opdrFilters.opdrachtnummer)
        })
        .filter(opdracht => {
          return opdracht.opdrachtgever.bedrijfsnaam?.toLowerCase().includes(store.state.opdrFilters.bedrijfsnaam.toLowerCase())
        })
        .filter(opdracht => {
          return opdracht.statusString?.toLowerCase().includes(store.state.opdrFilters.status.toLowerCase())
        })
        .filter(opdracht => {
          if (store.state.opdrFilters.disciplines == "") {
            return opdracht
          } else {
            return opdracht.aanvraag.discipline.includes(store.state.opdrFilters.disciplines)
          }
        })
    },

    opdrachtenFilteredByCurrentView() {
      const isView = view => this.selectedView === view
      let actieveOpdrachten = this.orderBy(
        this.filteredOpdrachten.filter(e => !e.geannuleerd && !e.onhold && !e.gearchiveerd && !(e.status && e.status[e.status?.length - 1].event < 10)),
        "metadata.opdrachtNummer",
        -1
      )
      if (isView("alle")) return actieveOpdrachten
      if (isView("nieuw")) return actieveOpdrachten.filter(e => e.statusString === "Nieuw" || e.statusString === "In behandeling" || e.statusString === "Uitgezet")
      if (isView("geaccepteerd")) return actieveOpdrachten.filter(e => e.statusString === "Geaccepteerd" || e.statusString === "Intake")
      if (isView("lopend")) {
        return actieveOpdrachten.filter(e => {
          return e.statusString === "Gestart" || e.facturen.length
        })
      }
      if (isView("gearchiveerd"))
        return this.orderBy(
          this.filteredOpdrachten.filter(e => e.geannuleerd || e.onhold || e.gearchiveerd || (e.status && e.status[e.status?.length - 1].event < 10)),
          "opdrachtnummer",
          -1
        )
      return []
    }
  }
}
</script>

<style scoped>
.page {
  padding-top: 30px;
}

.selected {
  box-shadow: inset 3px 0 0 blue;
}

.toggleholder {
  display: flex;
  flex-direction: row;
}

.listholder {
  padding-bottom: 100px;
}
.listtitle {
  font-weight: 600;
  padding-bottom: 20px;
}

.bolletje {
  background-color: red;
  width: 10px;
  height: 10px;
  border-radius: 1000px;
  margin-left: 8px;
}

.selectorsContainer {
  display: flex;
  flex-direction: row;
  width: fit-content;
  padding-bottom: 30px;
  font-weight: 500;
}

.container {
  display: flex;
  flex-direction: row;
  width: fit-content;
  padding-right: 20px;
}

.selector {
  font-size: 15px;
  padding: 10px 15px;
  border: 1px solid lightgray;
  margin-right: -1px;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.selector:hover {
  color: #3076ea;
}

.activeList {
  background-color: #3076ea;
  color: #fff !important;
}

.activeListOrange {
  background-color: #ff9326;
  color: #fff !important;
}
.activeListRed {
  background-color: rgb(241, 100, 108);
  color: #fff !important;
}
</style>
